import { makeStyles } from '../../../../../../styles';
export const useStyles = makeStyles((theme) => ({
    delete: {
        height: theme.spacing(1.5),
        width: theme.spacing(1.5),
    },
}));
//# sourceMappingURL=MultiValueRemove.styles.js.map